import { ActiveCompany } from "./types";

export const DEFAULT_COMPANY: ActiveCompany = {
  company_id: "",
  company_name: "Select Company",
  company_type: "Type",
};
